import { http, pagination } from 'utils'
import { concat, set, findIndex, sortBy } from 'lodash'
import { SET_MANAGERS, SET_META, SET_MANAGER, ADD_MANAGERS, ADD_MANAGER, SET_PROPERTY } from 'vx/mutations'

const initialManagerState = () => ({
  agency_id: null,
  first_name: null,
  last_name: null,
  email: null,
  phone: null
})

// Managers state.
const state = {
  manager: initialManagerState(),
  managers: [],
  meta: null
}

// Managers state getters.
const getters = {
  managersAlpha: (state) => {
    return sortBy(state.managers, 'name')
  }
}

// Managers actions
const actions = {
  /**
   * Get all managers.
   *
   * @return Promise
   */
  async getManagers ({ commit }, { next = false, params = {} } = {}) {
    if (next) {
      if (pagination(state.meta)) {
        return Promise.reject(new Error('No more results.'))
      }

      params.page = state.meta.current_page + 1
    }

    const response = await http.get('managers', { params })

    if (next) {
      commit(ADD_MANAGERS, response.data.data)
    } else {
      commit(SET_MANAGERS, response.data.data)
    }

    commit(SET_META, response.data.meta)

    return response
  },

  async storeManager ({ commit }, payload) {
    const response = await http.post('managers', payload)

    commit(SET_MANAGER, response.data.data)

    return response
  },

  setManagerProperty ({ commit }, payload) {
    commit(SET_PROPERTY, payload)
  },

  addManager ({ commit }, manager) {
    commit(ADD_MANAGER, manager)
  },

  resetManager ({ commit }) {
    commit(SET_MANAGER, initialManagerState())
  },

  resetManagers ({ commit }) {
    commit(SET_MANAGERS, [])
  }
}

// Managers state mutations.
const mutations = {
  [SET_MANAGER] (state, manager) {
    state.manager = manager
  },

  [SET_MANAGERS] (state, managers) {
    state.managers = managers
  },

  [ADD_MANAGERS] (state, managers) {
    state.managers = concat(state.managers, managers)
  },

  [ADD_MANAGER] (state, manager) {
    let index = findIndex(state.managers, existing => existing.id === manager.id)

    if (index === -1) {
      state.managers.unshift(manager)
    } else {
      state.managers.splice(index, 1, manager)
    }
  },

  [SET_META] (state, meta) {
    state.meta = meta
  },

  [SET_PROPERTY] (state, { property, value }) {
    set(state.manager, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
